/**
 *  @class
 *  @function Gallery
 */
if (!customElements.get('theme-gallery')) {
  class ThemeGallery extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.galleryVideoList = Array.from(this.querySelectorAll('.gallery--item .gallery__video'));

      if(this.getAttribute('data-masonry') == 'true'){
        this.galleryVideoList= Array.from(this.querySelectorAll('.gallery--item video'));
         this.watchPlay()
        this.masonry();
      }else if(this.getAttribute('data-scoll') == 'true'){
        this.galleryVideoList= Array.from(this.querySelectorAll('.gallery--item video'));
        this.watchPlay()
        this.scroll();
      }else{
      this.hoverPlayList = this.galleryVideoList.filter((item) => {
        return item.classList.contains('hover-play') && item;
      });

      this.autoPlayList = this.galleryVideoList.filter((item) => {
        return !item.classList.contains('hover-play') && item;
      });

      this.autoPlayList.forEach((item, i) => {
        item.querySelector('video').play();
      });

      this.setHoverPlayList();
      }
    }
    watchPlay(){
      this.galleryVideoList.forEach((video, i) => {
        video.addEventListener('play', () => {
          this.galleryVideoList.forEach(otherVideo => {
            if (otherVideo !== video && !otherVideo.paused) {
                otherVideo.pause(); 
            }
          });
        });
      });
    }
    setHoverPlayList() {
      this.hoverPlayList.forEach((item, i) => {
        item.querySelector('video').currentTime = 0.1;
        item.parentElement.addEventListener('mouseenter', () => this.playVideo(item));
        item.parentElement.addEventListener('mouseleave', () => this.pauseVideo(item));
      });
    }

    playVideo(videoContainer) {
      videoContainer.querySelector('video').play();
    }
    pauseVideo(videoContainer) {
      videoContainer.querySelector('video').pause();
    }
    masonry(){
      let showBtnEl = this.querySelector("#showMoreBtn");
      let allItems= this.querySelector(".gallery--inner").querySelectorAll(':nth-child(n+7)')
      showBtnEl?showBtnEl.addEventListener("click",()=>{
        allItems.forEach((item, i) => {
          item.style.display=item.computedStyleMap().get("display").value=="none"?"block":"none";
        })
        showBtnEl.querySelector("span").innerHTML=showBtnEl.querySelector("span").innerHTML=="Show More"?"Hide More":"Show More";
      }):''
    }
    scroll(){
      this.parentElement.querySelector(".flickity-prev").addEventListener("click",()=>{
        this.scrollTo({
          left: this.scrollLeft-this.offsetWidth,
          behavior: 'smooth'
        });
      })
      this.parentElement.querySelector(".flickity-next").addEventListener("click",()=>{
        this.scrollTo({
          left: this.scrollLeft+this.offsetWidth,
          behavior: 'smooth'
        });
      })
    }
  }
  customElements.define('theme-gallery', ThemeGallery);
}